import { render, staticRenderFns } from "./accordion.vue?vue&type=template&id=75fb5fdb&scoped=true&"
import script from "./accordion.js?vue&type=script&lang=js&"
export * from "./accordion.js?vue&type=script&lang=js&"
import style0 from "./accordion.scss?vue&type=style&index=0&id=75fb5fdb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75fb5fdb",
  null
  
)

export default component.exports